import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { useQuery } from "@tanstack/react-query"

export type UseTrackerIntegrationOptionsProps<T> = {
  filters?: {
    search?: string
  },
  mapper?: (data: any) => T,
}

export const useTrackerIntegrationOptions = <T,>({
  filters: { search } = {},
  mapper = Mapper.default<T>(),
}: UseTrackerIntegrationOptionsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['trackerIntegrationsOptions', search],
    queryFn: () => privateAxios.get(`/client/tracker_integration_options`, {
      params: {
        search,
      }
    }),
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
  })

  return { data, meta, isPending, ...rest }
}
